import { LanguageLevel } from 'model';

// Constants.
// -----------------------------------------------------------------------------
export const LEVEL_NOT_DEFINED: LanguageLevel = 'not-defined';
export const DEFAULT_FROM_LINKEDIN = false;
export const DEFAULT_HAS_TECHNOLOGIES = false;
